import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {PostBeneficiaryModel, PostBeneficiary, PostBeneficiaryParams} from 'domain/usecases';
import {APIError} from 'data/errors/api-error';

export class RemotePostBeneficiary implements PostBeneficiary {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostBeneficiaryModel>,
	) {}

	async post(params: PostBeneficiaryParams): Promise<PostBeneficiaryModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body: params,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
